import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { ToastContainer } from 'react-toastify';

import {LeadDataAPI, CallerAPI, LeadAssignCallerAPI} from "./../../../API/Team/LeadAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";


const Lead = () =>{

    const [leads, setLeads] = useState([]);
    const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [dispositions, setDispositions] = useState([]);       
    const [filteremail, setFilterEmail] = useState("");
    const [filtername, setFilterName] = useState("");
    const [callers, setCallers] = useState([]);
    const [isleadassign, setIsLeadAssign] = useState(false);
    const [stages, setStages] = useState([]);
    const [program, setPrograms] = useState([]);
    const [institute, setInstitutes] = useState([]);
    const [filterstage, setFilterStage] = useState("");
    const [filterdisposition, setFilterDisposition] = useState("");
    const [filtercaller, setFilterCaller] = useState("");
    const[showcustomdates, setShowCustomDates] = useState(false);
    const[datefilteroption, setDateFilterOption] = useState("");
    const[startdate, setStartDate] = useState("");
    const[enddate, setEndDate] = useState("");
    const [filterprogram, setFilterProgram] = useState("");
    const [filterinstitute, setFilterInstitute] = useState("");
    const [filtercontact, setFilterContact] = useState("");
    const [filtersStored, setFiltersStored] = useState(null);
    const [filtersDraft, setFiltersDraft] = useState({ 
                                                    filterstage: "",
                                                    filterdisposition: "",
                                                    filterprogram: "",
                                                    filterinstitute: "",
                                                    filterdateoption: "",
                                                    filterstartdate: "",
                                                    filterenddate: "",
                                                    filtername: "",
                                                    filteremail: "",
                                                    filtercontact: "",
                                                    filtercaller: ""
                                                });


    const perpagedata = 20;


    useEffect(() => {

        if(showleads)
        {
            CallerAPI(setCallers);
            LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setCallers, "", setIsLeadAssign);
        }

    }, [isleadassign]);

    useEffect(() => {
    
        console.log("Step 1");

        if (!filtersStored) return;

        console.log("Step 2");
        const params = new URLSearchParams();
        console.log("Step 3");
        Object.keys(filtersStored).forEach(key => {
            if (filtersStored[key]) {
                params.append(key, filtersStored[key]);
            }
        });

        console.log("Step 4");

        params.append("page", currentPage);
        params.append("per_page", perpagedata);
        console.log("Step 5");
        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setCallers, params, false);

    }, [filtersStored, currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

   

    const handleFilterLeadStatus = (e) =>{
        setFilterDisposition(e.target.value);
    }

    const handleFilterEmail =(e) =>{

        setFilterEmail(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filteremail: e.target.value
                        }));
    }

    const handleFilterStage = (e) =>{
        setFilterStage(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterstage: e.target.value
                        }));
    }

    const handleFilterDispositon = (e) =>{
        setFilterDisposition(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterdisposition: e.target.value
                        }));
    }

    const handleFilterProgram = (e) =>{
        setFilterProgram(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterprogram: e.target.value
                        }));
    }

    const handleFilterInstitute = (e) =>{
        setFilterInstitute(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterinstitute: e.target.value
                        }));
    }

    const handleFilterName = (e) =>{
        setFilterName(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtername: e.target.value
                        }));
    }

    const handleDateFilterOption = (e) =>{

        console.log(e.target.value);

        setDateFilterOption(e.target.value);

        if(e.target.value === 'customdate')
        {
            setShowCustomDates(true);

            setFiltersDraft(prev => ({
                            ...prev,
                            filterdateoption: e.target.value
                        }));
        }
        else
        {
            setShowCustomDates(false);
            setStartDate("");
            setEndDate("");

            setFiltersDraft(prev => ({
                            ...prev,
                            filterdateoption: e.target.value,
                            filterstartdate: "",
                            filterenddate: ""
                        }));
        }

        

        

    }

    const handleStartDate = (e) =>{
        setStartDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterstartdate: e.target.value
                        }));
    }

    const handleEndDate = (e) =>{
        setEndDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterenddate: e.target.value
                        }));
    }

    const handleFilterCaller = (e) =>{
        console.log(e.target.value);
        setFilterCaller(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercaller: e.target.value
                        }));
    }

    const handleFilterContact = (e) =>{

        setFilterContact(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercontact: e.target.value
                        }));
    }

    const handleApplyFilter = () =>{

        console.log('Filter Name====' + filtername);
        console.log('Filter Email====' + filteremail);
        console.log('Filter Disposition====' + filterdisposition);

        setFiltersStored({
                            ...filtersDraft,
                            //page: 1
                        });

        setCurrentPage(1);
    }

    const handleResetFilter = (e) =>{

        setFilterStage("");
        setFilterDisposition("");
        setFilterProgram("");
        setFilterInstitute("");
        setDateFilterOption("");
        setStartDate("");
        setEndDate("");
        setFilterName("");
        setFilterEmail("");
        setFilterContact("");
        setFilterCaller("");
        //setSelectCaller("");
        //setShowCallerStats(false);
        //setSelectCampaign("");
        //setSelectCaller("");
        //setSelectStage("");
        //setSelectDisposition("");
        //setSelectSubDisposition("");

        setFiltersDraft({
                    filterstage: "",
                    filterdisposition: "",
                    filterprogram: "",
                    filterinstitute: "",
                    filterdateoption: "",
                    filterstartdate: "",
                    filterenddate: "",
                    filteremail: "",
                    filtername: "",
                    filtercontact: "",
                    filtercaller: ""
        });

        setFiltersStored(null);
        setCurrentPage(1);
        
        //LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, null);
        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setCallers, "", false);
    }

    /*const handleFilterLeads = () =>{

        console.log('Filter Name====' + filtername);
        console.log('Filter Email====' + filteremail);
        console.log('Filter Disposition====' + filterdisposition);

        const filterparams = new URLSearchParams();

        if(filtername)
        {
            filterparams.append('filtername', filtername);
        }

        if(filteremail)
        {
            filterparams.append('filteremail', filteremail);
        }

        if(filterdisposition)
        {
            filterparams.append('filterdisposition', filterdisposition);
        }

        if(currentPage)
        {
            filterparams.append('page', currentPage);
        }

        if(perpagedata)
        {
            filterparams.append('per_page', perpagedata);
        }

        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setDispositions, filterparams);
    }*/

    const handleLeadAssign = (e, leadid) =>{
        
        console.log('caller id===' + e.target.value);
        console.log('Lead id===' + leadid);

        const callerid = e.target.value;

        const params = {
                        'callerid': callerid,
                        'leadid': leadid
                    };

        LeadAssignCallerAPI(params, setIsLeadAssign);
    }


    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Leads</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card">
                            <div className="align-items-center kanban-filter">
                                <div className="row"> 
                                    <div className="col-md-2 date-filter dropdown me-2 mb-2">
                                        <select className="form-select" name="leadcaller-filter" onChange={handleFilterCaller} value={filtercaller}>
                                            <option value="">Select Caller</option>
                                            {callers?.map((callerlist) =>
                                                <option key={callerlist.id} value={callerlist.id}>{callerlist.name}</option>
                                            )}
                                                                                    
                                        </select>
                                    </div>                               
                                    <div className="col-md-2 date-filter dropdown me-2 mb-2">
                                        <select className="form-select" name="leadstage-filter" onChange={handleFilterStage} value={filterstage}>
                                            <option value="">Select Stage</option>
                                            {stages?.map((stagelist) =>
                                                <option key={stagelist.id} value={stagelist.id}>{stagelist.name}</option>
                                            )}
                                                                                    
                                        </select>
                                    </div>
                                    <div className="col-md-3 date-filter dropdown me-2 mb-2">
                                        <select className="form-select" name="leaddisposition-filter" onChange={handleFilterDispositon} value={filterdisposition}>
                                            <option value="">Select Dispositions</option>
                                            {dispositions.map((dispositionlist) =>
                                                <option key={dispositionlist.id} value={dispositionlist.id}>{dispositionlist.name}</option>
                                            )}
                                                                                    
                                        </select>
                                    </div>
                                    <div className="col-md-2 date-filter dropdown me-2 mb-2">
                                        <select className="form-select" name="leadprogram-filter" onChange={handleFilterProgram} value={filterprogram}>
                                            <option value="">Select Program</option>
                                            {program?.map((programlist) =>
                                                <option key={programlist} value={programlist}>{programlist}</option>
                                            )}
                                                                                    
                                        </select>
                                    </div>
                                    <div className="col-md-2 date-filter dropdown me-2 mb-2">
                                        <select className="form-select" name="leadinstitute-filter" onChange={handleFilterInstitute} value={filterinstitute}>
                                            <option value="">Select Institute</option>
                                            {institute?.map((institutelist) =>
                                                <option key={institutelist} value={institutelist}>{institutelist}</option>
                                            )}
                                                                                    
                                        </select>
                                    </div>
                                    <div className="col-md-2 date-filter dropdown me-2">
                                        <select className="form-select" name="date-filter" onChange={handleDateFilterOption} value={datefilteroption}>
                                            <option value="">Select Date</option>
                                            <option value="today">Today</option>
                                            <option value="yesterday">Yesterday</option>
                                            <option value="last7days">Last 7 Days</option>
                                            <option value="last30days">Last 30 Days</option>
                                            <option value="thismonth">This Month</option>
                                            <option value="lastmonth">Last Month</option>
                                            <option value="customdate">Custom Date</option>
                                        </select>
                                    </div>
                                    <div className={ showcustomdates ? 'col-md-2 custom-date-filter dropdown me-2 mb-2' : 'col-md-2 custom-date-filter dropdown me-2 mb-2 d-none'}>
                                        <input className="form-control" type="date" name="startdate" placeholder="Start Date" onChange={handleStartDate} value={startdate} />                                        
                                    </div>
                                    <div className={ showcustomdates ? 'col-md-2 custom-date-filter dropdown me-2 mb-2' : 'col-md-2 custom-date-filter dropdown me-2 mb-2 d-none'}>
                                        <input className="form-control" type="date" name="enddate" placeholder="End Date" onChange={handleEndDate} value={enddate} />
                                    </div>

                                    <div className="col-md-2 date-filter dropdown me-2 mb-2">
                                        <input className="form-control" type="text" name="filtername" onChange={handleFilterName} placeholder="Enter name" value={filtername} />                                         
                                    </div>

                                    <div className="col-md-2 date-filter dropdown me-2 mb-2">
                                        <input className="form-control" type="email" name="filteremail" onChange={handleFilterEmail} placeholder="Enter email" value={filteremail} />                                        
                                    </div>

                                    <div className="col-md-2 dropdown me-2 mb-2">
                                        <input className="form-control" type="text" name="filtercontact" onChange={handleFilterContact} placeholder="Enter phone" value={filtercontact} />                                        
                                    </div>
                                    {/*<div className="date-filter dropdown me-2">
                                        <select className="form-select" name="leadsubdisposition-filter" onChange={handleFilterSubdisposition}>
                                            <option value="">Select SubDispositions</option>
                                            {subdispositions.map((subdispositionlist) =>
                                                <option key={subdispositionlist.id} value={subdispositionlist.id}>{subdispositionlist.name}</option>
                                            )}
                                                                                    
                                        </select>
                                    </div>
                                
                                    <div className="email-filter me-2">
                                        <input className="form-control" type="email" name="filteremail" onChange={handleInputEmailFilter} placeholder="Enter email" />
                                    </div>

                                    <div className="email-filter me-2">
                                        <input className="form-control" type="text" name="filtername" onChange={handleInputNameFilter} placeholder="Enter name" />
                                    </div>*/}

                                    <div className="col-md-3 mb-2">
                                        <button type="button" className="btn btn-primary me-2" onClick={handleApplyFilter}>
                                                <i className="ti ti-search me-2"></i>Apply Filter
                                        </button>

                                        <button type="button" className="btn btn-dark" onClick={handleResetFilter}>
                                            <i className="fa fa-undo me-2"></i>Clear
                                        </button>
                                    </div>
                                    {/*<div className="col-md-2 mb-2">
                                        
                                    </div>*/}
                                    {/*<div className="button-filter me-2">
                                        <button type="button" className="btn btn-primary" onClick={handleFilterLeads}>
                                            <i className="ti ti-search me-2"></i>Apply Filter
                                        </button>
                                        
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card">

                            <div className="card-body">
                                                            
                                <div className="table-responsive">
                                    
                                    <table className="table" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Contact</th>                                                
                                                <th>Location</th>
                                                <th>Program</th>
                                                <th>Institute</th>
                                                <th>Source</th>
                                                <th>Call Count</th>
                                                <th>Lead Status</th>                                                
                                                <th>Lead Assign</th>
                                                <th>Updated Date</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="11">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            ((leads !== "" && leads !== null && leads !== undefined)  ? 
                                                ( leads?.map(lead => 
                                                    (
                                                        
                                                        <tr key={lead.id}>
                                                            <td>
                                                                <Link to={`/team/lead-profile/${lead.id}`} class="">
                                                                    <i className="fa fa-pencil "></i>
                                                                </Link>										
                                                            </td>
                                                            <td>{lead.name}</td>
                                                            <td>{lead.email}</td>                                                         
                                                            <td>{lead.contact}</td> 
                                                            <td>{lead.location}</td>
                                                            <td>{lead.program}</td>                                                        
                                                            <td>{lead.institute}</td>                                                        
                                                            <td>{lead.source}</td>                                                        
                                                            <td>{lead.callcount}</td>                                                        
                                                            <td>
                                                                {lead.leadstatus ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                                :
                                                                    <span>-</span>
                                                                }
                                                            </td>
                                                            <td>
                                                                <select className="form-select" name="caller" value={lead.telecaller_id} onChange={(e) => handleLeadAssign(e, lead.id) }>
                                                                    <option value="">Select Caller</option>
                                                                    {callers?.map((caller) =>
                                                                        (
                                                                            <option key={caller.id} value={caller.id}>{caller.name}</option>
                                                                            
                                                                        ))                                        
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td>
                                                                {lead.calleddate ?
                                                                    (moment(lead.created_at).format('DD-MM-YYYY h:mm'))
                                                                :
                                                                    (moment(lead.created_at).format('DD-MM-YYYY h:mm'))
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="11">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="pagination-section mt-3">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>
        <ToastContainer />

    </div>
    )
}

export default Lead;